import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    rowContainer: {
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap",
        width: "100%"
    },
    switchesContainer: {
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap",
        width: "100%"
    },
    rowSpaceBetween: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        width: "100%"
    },
    borderedCard: {
        backgroundColor: "transparent"
    },
    scrollContent: {
        justifyContent: "center",
        alignItems: "center"
    },
    previewContainer: {
        justifyContent: "center",
        alignItems: "center",
        minHeight: 120
    },
    paddedMarginContainer: {
        justifyContent: "center",
        alignItems: "center",
        minHeight: 120
    },
    descText: {
        marginBottom: 20
    },
    marginContainer: {
        marginBottom: 20
    },
    contentContainer: {
        maxWidth: 850,
        width: "100%"
    },
    container: {
        flex: 1
    }
});
export default stylesheet;
